module.exports = __webpack_public_path__ + "img/16.8b361541.jpg";